import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";
import type { SponsorLayout } from "src/types";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import { BlockMaxWidthWrapper } from "@/components/editor/shared/block-wrapper";
import SponsorsSettings from "@/components/editor/shared/sponsors/sponsors-settings/sponsors-settings-component";
import { DEFAULT_TIER_TITLES } from "@/features/sponsors/sponsors-reducer";

import {
  BackgroundColorWrapper,
  CenteredHeader,
  PaddingWrapper,
  StyledSponsorsList,
} from "./sponsors-component-styles";

type SponsorsProps = {
  children: React.ReactNode;
  layout: SponsorLayout;
};

export default function Sponsors({ children, layout }: SponsorsProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BackgroundColorWrapper ref={connect} id={nodeId}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper maxWidth={rem(1250)}>
          <CenteredHeader>
            <Element
              id="sponsor-title"
              is={Text}
              element="h2"
              text={DEFAULT_TIER_TITLES[layout]}
              pattern="headingTwo"
            />
          </CenteredHeader>
          <StyledSponsorsList layout={layout}>{children}</StyledSponsorsList>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BackgroundColorWrapper>
  );
}

Sponsors.craft = {
  custom: {
    displayName: "Sponsors",
  },
  isCanvas: true,
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: SponsorsSettings,
  },
};
